import React from 'react'
import Lottie from 'react-lottie';
import animationData from '../Lotties/AIAnimation.json';
import './styles.css';

function Pal() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };  
  return (
    <div id ="pal-container">
        <Lottie 
            options={defaultOptions}
            height={130}
            width={110}
  />
  
  </div>
  )
}

export default Pal;